import EditorPlaceholder from '../components/builder/EditorPlaceholder/EditorPlaceholder';
import Preview from '../components/builder/Preview/Preview';
import useMediaQuery from '../hooks/useMediaQuery';

export const BuilderRoute = () => {
  const isMobile = useMediaQuery({ max: 991 });
  return isMobile ? <Preview /> : <EditorPlaceholder />;
};
